import { AbstractControl, ValidatorFn } from '@angular/forms';

export function isInteger() : ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isValid = Number.isInteger(Number(control.value));
    return isValid ? null : { 'notInteger': { value: control.value } };
  };
}

